import React from 'react';

const Footer = () => (
    
<footer class="bg-white dark:bg-gray-800 w-full py-8">
    <div class="max-w-screen-xl mx-auto px-4">
        
       
        <div class="text-center text-gray-500 dark:text-gray-200 pt-10 sm:pt-12 font-medium flex items-center justify-center">
        ©2022 Techmillennials. All Rights Reserved.
        </div>
    </div>

  </footer>
);

export default Footer;